import { InputLabel } from '@components/Common';
import { Warning } from '@components/Common/SharedStyles';
import { formatDateTime } from '@helpers/formatting';
import { TankBalance } from '@api/queries/tanks';
import React from 'react';
import styled from 'styled-components';
import { TFunction } from '~types/types';

const BalanceContainer = styled.div`
  margin: 10px 0 5px 0;
`;

const StyledLabel = styled(InputLabel)`
  display: inline-block;
  width: auto;
  margin: 0 10px 0 0;
  padding: 0;
`;

interface Props {
  balance: TankBalance;
  t: TFunction;
}

const TankWarning = (props: Props) => {
  return <Warning>{props.t('approval.warning_product_undefined')}</Warning>;
};

const TankInfo = (props: Props) => {
  const { balance, t } = props;
  return (
    <>
      <StyledLabel>{t('approval.last_defined_status')}:</StyledLabel>
      <em>{balance.weight} kg</em> {' - '}
      <em>
        {balance.product.name} ({balance.product.code})
      </em>{' '}
      {' - '}
      <em>{formatDateTime(balance.timestamp, true)}</em>
    </>
  );
};

export const TankInformation = (props: Props) => {
  return <BalanceContainer>{props.balance ? <TankInfo {...props} /> : <TankWarning {...props} />}</BalanceContainer>;
};
